enum NOTIFICATION_TYPES {
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  INFO = 'INFO',
  CUSTOM = 'CUSTOM'
}

export default NOTIFICATION_TYPES;
